import leaveStore from "./leave/store";
import exemptionStore from "./exemption/store";

export default {
  namespaced: true,
  modules: {
    leave: leaveStore,
    exemption: exemptionStore,
  },
};
